import { Checkbox } from '@mui/material';
import React from 'react'
import CouponConfigurableLabel from '../CouponConfigurableLabel';
import { useSelector } from 'react-redux';
import { updateIsPeriodWelcome } from '../../../../stateManagement/actions/manageCouponActions'

/**
 * This component is a general component which is a radio selector
 * Options : List of option of radio selector fileds 
 * direction : direction of options
 * selectedValue : selected option
 * handleChange : this function gets executed when there any selection is done in radio field
 * @param props 
 * @returns 
 */

function PeriodicUsabilityCheckBox(props: any): any {
    let isPeriodWelcome: boolean = useSelector((state: any) => state?.manageCoupons?.data?.isPeriodWelcome);
    const { options, selectedValue, handleChange, direction = "row" } = props;
    const handleCheckBoxChange = () => {
        if (isPeriodWelcome) {
            updateIsPeriodWelcome(false);
        }
        else {
            updateIsPeriodWelcome(true);
        }

    }

    return (
        //   <div className="Coupon-radio-selector-wrapper">
        <div style={{ "marginTop": '1rem' }}>
            <CouponConfigurableLabel text={'IS_PERIOD_WELCOME'} style={{ color: 'inherit', cursor: 'default', fontWeight: '500' }} />
            <Checkbox checked={isPeriodWelcome} onChange={handleCheckBoxChange} className='select-checkbox' />
        </div>
        //   </div>
    )
}

export default PeriodicUsabilityCheckBox;